export const DISPLAY_VARIANT_PRIMARY = 'primary';

export const DISPLAY_VARIANT_SECONDARY = 'secondary';
